export const StatutoryCommitteeActions = {
  GET_STATUTORY_COMMITTEE: "GET_STATUTORY_COMMITTEE",
  SET_STATUTORY_COMMITTEE: "SET_STATUTORY_COMMITTEE",

  GET_STATUTORY_COMMITTEE_SUBPAGE: "GET_STATUTORY_COMMITTEE_SUBPAGE",
  SET_STATUTORY_COMMITTEE_SUBPAGE: "SET_STATUTORY_COMMITTEE_SUBPAGE",
};

